import { render, staticRenderFns } from "./introductionTeacher.vue?vue&type=template&id=2ee26b38"
import script from "./introductionTeacher.vue?vue&type=script&lang=js"
export * from "./introductionTeacher.vue?vue&type=script&lang=js"
import style0 from "./introductionTeacher.vue?vue&type=style&index=0&id=2ee26b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports